import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import { addDetailImage, deleteDetailImage, getDetailImage } from 'app/redux/store/features/classes'
import ChangeDetailImageUplaod from './ChangeDetailImageUplaod'
import { updateIndicator } from 'app/redux/store/features/configs'

const UpdateDetailImage = ({ filePathDetailData }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const { state } = useLocation()
    const { classId } = state
    const { classDetailImage, loading, error } = useSelector((state) => state.classes)
    const [detailImage, setDetailImage] = useState({ ...classDetailImage, file: [] })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)

    const handleError = useCallback(
        (error) => {
            if (error.status === '401') {
                navigate('/profile/signout')
            } else if (error.detail) {
                enqueueSnackbar(error.detail, {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                })
            } else {
                enqueueSnackbar(error, {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                })
            }
        },
        [enqueueSnackbar, navigate]
    )

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Operation completed successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            dispatch(updateIndicator({ inProgress: false }))
            navigate('/courses/setup/classes', { state: { navigateFrom: 'update-class' } })
        }
    }, [loading])

    useEffect(() => {
        if (!utilServices.isNullOrUndefined(classId)) {
            dispatch(getDetailImage({ id: classId }))
        }
    }, [])

    useEffect(() => {
        setDetailImage({ ...classDetailImage, file: [] })
        setSelectedFile(null)
    }, [classDetailImage])

    const onAddDetailImage = useCallback(
        (e) => {
            if (!selectedFile) {
                enqueueSnackbar('Please select an image and try again', {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                })

                e.preventDefault()
                return
            }
            e.preventDefault()
            setApiCallInProgress(true)

            const form = new FormData()
            form.append('id', classId)
            form.append('image', selectedFile)

            dispatch(
                addDetailImage(form, {
                    'Content-Type': 'multipart/form-data',
                })
            )
                .then(() => {
                    setApiCallInProgress(false)
                    dispatch(getDetailImage({ id: classId }))
                })
                .catch(handleError)
        },
        [selectedFile, classId]
    )

    const onRemoveDetailImage = useCallback((e) => {
        e.event.preventDefault()
        setApiCallInProgress(true)
        dispatch(deleteDetailImage({ id: classId }))
    }, [])

    return (
        <React.Fragment>
            <ChangeDetailImageUplaod
                filePathDetailData={filePathDetailData}
                detailImage={detailImage}
                selectedFile={selectedFile}
                onSelectedFileChange={setSelectedFile}
                onRemoveDetailImage={onRemoveDetailImage}
                onAddDetailImage={onAddDetailImage}
            />
        </React.Fragment>
    )
}

export default UpdateDetailImage
